<template>
    <div v-if="hasPrice || hotelPageLink">
        <div v-if="hasPrice">
            <div class="client-price d-flex flex-nowrap" :class="{'justify-end': !mobile}">
                <div
                    :class="{title: mobile, 'text--primary': mobile}"
                    data-cy="client-price"
                    class="font-weight-medium"
                >
                    {{ $t('from') }} {{ minPrice }}
                </div>
                <corporate-policy-violation
                    v-if="minPriceRoomOffer.corporatePolicyViolation && searchRoomsCount === 1"
                    :policies="minPriceRoomOffer.corporatePolicy"
                />
            </div>
            <discount-label v-if="searchRoomsCount === 1" :price="minPriceRoomOffer.price" />
            <commission-amount v-if="searchRoomsCount === 1" :commission="minPriceRoomOffer.price.commission" />
            <rate-note :room="minPriceRoomOffer" />
            <v-tooltip v-if="isShowDynamicRate" :text="$t('dynamic_rate')" location="bottom">
                <template v-slot:activator="{props}">
                    <v-icon v-bind="props" color="primary"> mdi-chart-line </v-icon>
                </template>
                <span>{{ $t('dynamic_rate') }}</span>
            </v-tooltip>
        </div>
        <v-btn
            v-if="hotelPageLink"
            variant="flat"
            :block="!mobile"
            color="primary"
            :class="{'my-2': !mobile}"
            :to="hotelPageLink"
        >
            {{ $t('book') }}
        </v-btn>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import RateNote from '~src/components/snippets/RateNote.vue'
    import CorporatePolicyViolation from '~/components/snippets/CorporatePolicyViolation.vue'

    @Component({
        components: {
            DiscountLabel,
            CommissionAmount,
            CorporatePolicyViolation,
            RateNote,
        },
    })
    export class HotelOfferPriceBlock extends Vue {
        @Prop({required: true}) offer
        @Prop({default: false, type: Boolean}) mobile
        @Prop({required: true}) searchRequest
        @Prop() hotelPageLink

        get minPrice() {
            return this.$filters.price(this.minPriceRoomOffer.price)
        }

        get minPriceRoomOffer() {
            return hotelsRuntimeStore.minPriceRoomOffer(this.offer)
        }

        get hasPrice() {
            return !!this.offer.rooms.some(room => room.price && room.price.amount)
        }

        get searchRoomsCount() {
            return this.searchRequest.rooms.length
        }
    }

    export default HotelOfferPriceBlock
</script>

<style scoped></style>
